export const TypingDots = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="14"
    viewBox="0 0 18 14"
    aria-hidden
  >
    <rect x="0" y="8" width="3" height="3" rx="1.5" fill="#71717a">
      <animateTransform
        attributeName="transform"
        type="translate"
        dur="1.2s"
        begin="0s"
        repeatCount="indefinite"
        values="0 0;0 -6;0 0;0 0"
        keyTimes="0;0.25;0.5;1"
        calcMode="spline"
        keySplines="0.4 0 0.2 1;0.4 0 0.2 1;0 0 1 1"
      />
      <animate
        attributeName="opacity"
        dur="1.2s"
        begin="0s"
        repeatCount="indefinite"
        values="0.4;1;0.6;0.4"
        keyTimes="0;0.25;0.5;1"
      />
    </rect>
    <rect x="6" y="8" width="3" height="3" rx="1.5" fill="#71717a">
      <animateTransform
        attributeName="transform"
        type="translate"
        dur="1.2s"
        begin="0.16s"
        repeatCount="indefinite"
        values="0 0;0 -6;0 0;0 0"
        keyTimes="0;0.25;0.5;1"
        calcMode="spline"
        keySplines="0.4 0 0.2 1;0.4 0 0.2 1;0 0 1 1"
      />
      <animate
        attributeName="opacity"
        dur="1.2s"
        begin="0.16s"
        repeatCount="indefinite"
        values="0.4;1;0.6;0.4"
        keyTimes="0;0.25;0.5;1"
      />
    </rect>
    <rect x="12" y="8" width="3" height="3" rx="1.5" fill="#71717a">
      <animateTransform
        attributeName="transform"
        type="translate"
        dur="1.2s"
        begin="0.32s"
        repeatCount="indefinite"
        values="0 0;0 -6;0 0;0 0"
        keyTimes="0;0.25;0.5;1"
        calcMode="spline"
        keySplines="0.4 0 0.2 1;0.4 0 0.2 1;0 0 1 1"
      />
      <animate
        attributeName="opacity"
        dur="1.2s"
        begin="0.32s"
        repeatCount="indefinite"
        values="0.4;1;0.6;0.4"
        keyTimes="0;0.25;0.5;1"
      />
    </rect>
  </svg>
);
